import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {usePresupuesto, useProyecto} from "../../../../../Profile.jsx";
import {useEditor} from "../../../../../../../App.jsx";
import SelectorProducto from "./SelectorProducto.jsx";

const ItemPresupuestoEditor = () => {
    const [item, setItem] = useState({
        presupuesto: '',  // Aquí se asignará el ID del presupuesto correspondiente
        keyring_id: '',
        unidades: 1,
        precio_por_unidad: 0,
        tipo_descuento: 'porcentaje',
        descuento_valor_fijo: 0,
    });

    // const {proyecto, setProyecto} = useProyecto();
    const {presupuesto, setPresupuesto} = usePresupuesto();

    const {stateEditor, setStateEditor} = useEditor();

    useEffect(() => {
        if (stateEditor.editorID && stateEditor.editorID !== 'add') {
            // Cargar los datos del ítem para editar
            axios.get(`/items/${stateEditor.editorID}/`)
                .then(response => {
                    setItem(response.data);
                })
                .catch(error => {
                    console.error('Error al cargar el ítem del presupuesto:', error);
                });
        }
    }, [stateEditor.editorID]);

    const handleChange = e => {
        const { name, value } = e.target;
        setItem(prevItem => ({
            ...prevItem,
            [name]: value,
        }));

    };

    /*useEffect(() => {
        console.log("itemmm", item)
    }   , [item])*/
    const handleSubmit = async () => {
        try {
            item.presupuesto = presupuesto.id;
            console.log("itemSubmit", item);
            if (stateEditor.editorID === 'add') {
                // Crear nuevo ítem
                axios.post('/items/', item)
                    .then(response => {
                        if (response.status === 201) {
                            alert('Ítem creado exitosamente.');
                            setStateEditor({
                                ...stateEditor,
                                editor: true,
                                editorID: presupuesto.id,
                                editorType: "presupuesto_viewer"
                            });
                        }
                    })
                    .catch(error => {
                        console.error('Error al crear el ítem del presupuesto:', error);
                    });
            } else {
                // Editar ítem existente
                axios.put(`/items/${stateEditor.editorID}/`, item)
                    .then(response => {
                        if (response.status === 200) {
                            console.log("response", response.data)
                            alert('Ítem modificado exitosamente.');
                            // setStateEditor({
                            //     ...stateEditor,
                            //     editor: true,
                            //     editorID: presupuesto.id,
                            //     editorType: "presupuesto_viewer"
                            // });
                        }
                    })
                    .catch(error => {
                        console.error('Error al modificar el ítem del presupuesto:', error);
                    });
            }
        } catch (error) {
            console.error('Error al guardar el ítem del presupuesto:', error);
        }
    };


    const handlePresupuesto = () => {
        setStateEditor({
            ...stateEditor,
            editor: true,
            editorID: presupuesto.id,
            editorType: "presupuesto_viewer"
        });
    }

    return (
        <div className="h-full mx-auto  text-gray-800 dark:bg-gray-800 dark:text-white">


                <div className="grid h-full w-full grid-cols-4 grid-rows-9 gap-4 bg-gray-600 p-2 rounded-lg shadow-md">

                    <div className="font-sans col-span-4 row-span-1 bg-gray-400 dark:bg-gray-700 bg-opacity-50 rounded-lg shadow-md flex justify-center items-center">
                        <h2 className='text-3xl '>
                            {stateEditor.editorID === 'add' ? 'Añadir Ítem' : 'Editar Ítem'}
                        </h2>
                    </div>
                    <div className="font-sans col-span-2 row-span-7 bg-gray-400 dark:bg-gray-700 bg-opacity-50 rounded-lg shadow-md ">
                        <SelectorProducto item={item} handleChange={handleChange}/>
                    </div>

                    <div className="font-sans col-span-2 row-span-7 bg-gray-400 dark:bg-gray-700 bg-opacity-50 rounded-lg shadow-md ">

                        <div className="mb-4">
                            <label className="text-gray-700 dark:text-gray-300 text-lg font-bold mb-2">Unidades</label>
                            <input
                                name="unidades"
                                value={item.unidades}
                                onChange={handleChange}
                                className="appearance-none block w-full bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white dark:focus:bg-gray-800"
                                type="number"
                                min="1"
                            />
                        </div>

                        <div className="mb-4">
                            <label className="text-gray-700 dark:text-gray-300 text-lg font-bold mb-2">Precio por Unidad</label>
                            <input
                                name="precio_por_unidad"
                                value={item.precio_por_unidad}
                                onChange={handleChange}
                                className="appearance-none block w-full bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white dark:focus:bg-gray-800"
                                type="number"
                                step="0.01"
                                min="0"
                            />
                        </div>

                        <div className="mb-4">
                            <label className="text-gray-700 dark:text-gray-300 text-lg font-bold mb-2">Tipo de Descuento</label>
                            <select
                                name="tipo_descuento"
                                value={item.tipo_descuento}
                                onChange={handleChange}
                                className="appearance-none block w-full bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white dark:focus:bg-gray-800"
                            >
                                <option value="porcentaje">Porcentaje</option>
                                <option value="fijo">Fijo</option>
                            </select>
                        </div>

                        <div className="mb-4">
                            <label className="text-gray-700 dark:text-gray-300 text-lg font-bold mb-2">Descuento Valor Fijo</label>
                            <input
                                name="descuento_valor_fijo"
                                value={item.descuento_valor_fijo}
                                onChange={handleChange}
                                className="appearance-none block w-full bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white dark:focus:bg-gray-800"
                                type="number"
                                step="0.01"
                                min="0"
                            />
                        </div>

                    </div>
                    <div className="font-sans col-span-4 row-span-1 bg-gray-400 dark:bg-gray-700 bg-opacity-50 rounded-lg shadow-md ">
                        <div className="flex items-center justify-between">
                            <button
                                onClick={handleSubmit}
                                className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                type="button"
                            >
                                {stateEditor.editorID === 'add' ? 'Añadir Ítem' : 'Actualizar Ítem'}
                            </button>
                            <button
                                className="bg-transparent hover:bg-gray-500 text-gray-700 dark:text-gray-300 font-semibold hover:text-white py-2 px-4 border border-gray-500 hover:border-transparent rounded"
                                type="button"
                                onClick={handlePresupuesto}
                            >
                                Presupuesto
                            </button>
                        </div>
                    </div>
                </div>




        </div>
    );
};

export default ItemPresupuestoEditor;
